import moment from 'moment'
import accounting from 'accounting'
import { codefansNetCC2PY } from './utils/pinyin'
import requestApi from './scripts/api'

import { setWindowStore } from './scripts/api_url_header'

function getQuery () {
  let arr = window.location.search.slice(1).split('&')
  let obj = {}
  arr.forEach((item) => {
    let pair = item.split('=')
    obj[pair[0]] = decodeURIComponent(pair[1])
  })
  return obj
}

let at = getQuery()['access_token']
if (at) {
  window.sessionStorage['access_token'] = at
} else {
  at = window.sessionStorage['access_token']
}

setWindowStore(at)

export default function (obj) {
  /**
   * @type {{data: (function()), methods: *, created: (function()), mounted: (function())}}
   * @deprecated
   */
  window.mixin = {
    data () {
      return {
        requestApi
      }
    },
    methods: Object.assign({}, obj, {
      // 公用方法
      /**
       * 格式化时间
       * @param {string|number|object|Array} dateTime - 时间，可以是一个字符串、时间戳、表示时间的对象、Date对象或者表示时间的数组
       * @param {string} [fmt] - 格式
       * @returns {string} 返回格式化后的日期时间，默认格式：2017年8月22日 11:22:33
       * @author 魏宏裕 <weihongyu@515cn.com>
       * @see [momentjs]{@tutorial http://momentjs.cn/}
       */
      formatDate (dateTime, fmt = 'YYYY年M月DD日 HH:mm:ss') {
        if (!dateTime) {
          return ''
        }
        moment.locale('zh-CN')
        dateTime = moment(dateTime).format(fmt)
        return dateTime
      },
      /**
       * 格式化货币
       * @param {number} currency - 需要格式化的数值
       * @param {string} [symbol='￥'] - 货币符号
       * @param {number} [precision=2] - 小数位数
       * @param {string} [thousand=','] - 千分位
       * @param {string} [decimal='.'] - 小数点分隔符
       * @returns {string}
       * @author 魏宏裕 <weihongyu@515cn.com>
       * @see [accounting.js]{@tutorial http://openexchangerates.github.io/accounting.js/}
       */
      formatCurrency (currency, symbol = '￥', precision = 2, thousand = ',', decimal = '.') {
        if (isNaN(currency) === true) {
          currency = 0
        }
        currency = accounting.formatMoney(currency, symbol, precision, thousand, decimal)
        return currency
      },
      /**
       * 转换拼音缩写
       * @param {string} value - 需要转化的文字
       * @returns {string} 转换后的拼音缩写
       */
      pinyin (value) {
        return codefansNetCC2PY(value)
      },
      /**
       * 获取页面权限
       * @param {string} code - 页面的权限码
       * @returns {Array}
       */
      getElementCode (code) {
        const currentWorkList = JSON.parse(window.sessionStorage.getItem('work_list'))
        for (let workItem of currentWorkList) {
          if (workItem.name === code) {
            return workItem.element_codes
          }
        }
        return []
      },
      setTableHeight () {
        var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        var searchHeight = document.getElementsByClassName('page-search')[0].offsetHeight
        var toolbarHeight = document.getElementsByClassName('page-toolbar')[0].offsetHeight
        var pagingHeight = document.getElementsByClassName('page-paging')[0].offsetHeight
        var headerHeight = document.getElementsByClassName('default-header')[0].offsetHeight
        var titleHeight = document.getElementsByClassName('content-title')[0].offsetHeight
        var footerHeight = document.getElementsByClassName('content-footer')[0].offsetHeight
        console.log(winHeight, searchHeight, toolbarHeight, pagingHeight, headerHeight, titleHeight, footerHeight)
        console.log(winHeight - searchHeight - toolbarHeight - pagingHeight - headerHeight - titleHeight - footerHeight)
        return (winHeight - searchHeight - toolbarHeight - pagingHeight - headerHeight - titleHeight - footerHeight)
      }
    }),
    created () {
      this.$Message.config({
        top: 50,
        duration: 3
      })
      this.$Loading.config({
        color: '#2196f3',
        failedColor: '#f44336',
        height: 3
      })
    },
    mounted () {
      // 如果有依赖dom必须存在的情况，就放到nextTick里面
      this.$nextTick(() => {
      })
    }
  }
}
